import { render, staticRenderFns } from "./ReportFamily.vue?vue&type=template&id=1f034acc&scoped=true"
import script from "./ReportFamily.ts?vue&type=script&lang=ts&external"
export * from "./ReportFamily.ts?vue&type=script&lang=ts&external"
import style0 from "./ReportFamily.scss?vue&type=style&index=0&id=1f034acc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f034acc",
  null
  
)

export default component.exports